// import React from "react";

import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../context/LanguageContext";
import logoWhite from "../../assets/images/logoWhite.png";

const FooterComp = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();

  return (
    <>
      <div className="bg-[#141C3A] h-auto  py-6 pb-8 w-full flex flex-col gap-y-2 text-white z-30 border-b">
        <div className="font-bold text-5xl sm:text-5xl flex flex-col gap-y-1 w-10/12 mx-auto ">
          <div className=" flex flex-col md:flex-row items-start md:items-center gap-x-5 gap-y-1 md:gap-y-0">
            <p className="flex gap-x-1">{t("footerComp", "text1")}</p>
            <img
              className=" w-[400px] mt-1"
              src={logoWhite}
              alt="logoWhite"
            />
          </div>
          <p className="text-xl sm:text-5xl"> {t("footerComp", "text2")}</p>
        </div>

        <div className=" w-10/12 mx-auto mt-8">
          <p>Register now! Take advantage of special offers!</p>
        </div>

        <div className=" w-10/12 mx-auto mt-8">
          <a
            target="_blank"
            onClick={() => {
              navigate("/supplier-application-form");
            }}
            className="cursor-pointer bg-yellow-color  text-black px-[32px] py-[10px] rounded-[100px] active:scale-90 transition-transform font-semibold"
          >
            {" "}
            {t("footerComp", "button")}
          </a>
        </div>
      </div>

      <div className="absolute lg:top-[40%] xl:top-[24%] 2xl:top-[3%] right-[10%] hidden lg:block z-10">
        <p className="lg:text-[200px] xl:text-[250px] 2xl:text-[300px] opacity-[33%] font-extrabold font-madimi tracking-wide">
          Shop
        </p>
      </div>
    </>
  );
};

export default FooterComp;
